module.exports = __webpack_public_path__ + "img/score-medium.a793078b.svg";